import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { Post } from '@app/core/interfaces/post.interface';

@Component({
  standalone: true,
  selector: 'ups-content-card',
  styleUrl: './content-card.component.scss',
  templateUrl: './content-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { 
    class: 'd-block bg-card rounded-lg' 
  },
  imports: [
    IonicModule,
    RouterModule
  ],
})
export class ContentCardComponent implements OnChanges {

  @Input() public data?: Post;
  @Input() @HostBinding('class.square') public isSquare: boolean = false;
  public url!: SafeResourceUrl;

  constructor(
    protected readonly sanitizer: DomSanitizer
  ) { }

  public ngOnChanges(changes: SimpleChanges): void{
    if (changes['data']?.currentValue && this.data!.contentOption) this.getVideo();
  }

  public stopProp(event: Event): void{ event.stopPropagation(); }

  public onImgError({ target }: any): void{ 
    target.src = `/assets/images/placeholder/ph${ this.isSquare? '_sq' : '' }.webp`; 
  }

  protected getVideo(): void{ this.url = this.sanitizer.bypassSecurityTrustResourceUrl(`https://youtube.com/embed/${ this.data!.videoSource }?controls=0&disablekb=1`); }
}
